import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07165810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoringdata" }
const _hoisted_2 = { class: "table__box" }
const _hoisted_3 = { class: "table__tr" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Date")
], -1))
const _hoisted_5 = { class: "table__body" }
const _hoisted_6 = { class: "table__tr" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "HR")
], -1))
const _hoisted_8 = { class: "table__body" }
const _hoisted_9 = { class: "table__tr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "RR")
], -1))
const _hoisted_11 = { class: "table__body" }
const _hoisted_12 = { class: "table__tr" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "SpO₂")
], -1))
const _hoisted_14 = { class: "table__body" }
const _hoisted_15 = { class: "table__tr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "UO 24h")
], -1))
const _hoisted_17 = { class: "table__body" }
const _hoisted_18 = { class: "table__tr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "GCS")
], -1))
const _hoisted_20 = { class: "table__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", { key: data }, _toDisplayString(data.track_date), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.heart_rate.imputation})
            }, _toDisplayString((data.heart_rate.value).toFixed(2)), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.resp_rate.imputation})
            }, _toDisplayString((data.resp_rate.value).toFixed(2)), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.spo2.imputation})
            }, _toDisplayString((data.spo2.value).toFixed(2)), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.urineoutput_24hr.imputation})
            }, _toDisplayString((data.urineoutput_24hr.value).toFixed(2)), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.gcs.imputation})
            }, _toDisplayString((data.gcs.value).toFixed(2)), 3))
          }), 128))
        ])
      ])
    ])
  ]))
}